import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Container } from '../../atoms/Layout';
const imgAltMap = {
    vf: 'Logo Mijn Vervangingsfonds',
    pf: 'Logo Mijn Participatiefonds',
    medewerkersportaal: 'Logo Medewerkersportaal',
    ssa: 'Logo SSA'
};
const widthMap = {
    vf: '132',
    pf: '132',
    medewerkersportaal: undefined,
    ssa: '132',
};
export const LoginHeader = props => {
    const imgAlt = imgAltMap[props.variant];
    const src = './assets/img/logo.svg';
    const width = widthMap[props.variant];
    return (_jsx(Container, { children: _jsx("span", Object.assign({ className: "navbar-brand" }, { children: props.variant == 'ssa' ?
                (_jsx("h4", Object.assign({ className: 'ssa' }, { children: _jsxs("a", Object.assign({ href: 'https://www.vfpf.nl/subsidie-sluitende-aanpak', target: "_blank", rel: "noreferrer" }, { children: [" ", _jsx("img", { src: src, width: width, height: 64, alt: imgAlt }), "Subsidie Sluitende Aanpak"] })) }))) : (_jsx("img", { src: src, width: width, height: 64, alt: imgAlt })) })) }));
};
